import { ModalRouteProps } from 'context/ModalRouter';
import React from 'react';
import Modal from 'components/shared/Modal';
import { usePostModal } from 'app/modules/posts/modules/post/hooks/usePostModal';
import PostLayoutVariant from 'app/modules/posts/modules/post/components/PostLayoutVariant';
import style from 'components/posts/detail/Details.module.scss';

type Props = ModalRouteProps;

const PostModal: React.FC<Props> = (props) => {
  const { queryParams, onClose } = usePostModal(props);

  return (
    <Modal
      classNames={{
        root: '!tw-left-0',
        modal:
          '!tw-w-full !tw-bg-grayscale-5 !tw-h-full !tw-flex !tw-max-h-full !tw-m-0 !tw-overflow-hidden xl:!tw-max-w-[90%] !tw-max-w-full !tw-flex-col',

        modalContainer: '!tw-flex',
        modalAnimationIn: style.slideEnterAnimation,
        modalAnimationOut: style.slideLeaveAnimation,
      }}
      focusTrapped={false}
      blockScroll={false}
      size="responsive"
      isContentHeightAutoResizable={false}
      modalManager={props.modalManager}
      dataCy={{
        wrapper: 'post-modal',
      }}
    >
      <PostLayoutVariant queryParams={queryParams} onClose={onClose} />
    </Modal>
  );
};

export default PostModal;
